import React from 'react';

const Instructions: React.FC = () => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 md:p-6">
      <h3 className="text-lg font-semibold text-blue-900 mb-3">Instructions</h3>
      <div className="space-y-2 text-sm text-blue-800">
        <p>• Use the QR scanner to scan ticket QR codes</p>
        <p>• If the scanner doesn't work, use the manual ticket input option</p>
        <p>• Review ticket details before marking as used</p>
        <p>• Each ticket can only be used once</p>
      </div>
    </div>
  );
};

export default Instructions;
export {};
